import React, {memo} from 'react'
import {goBack} from '../../util'
import {cache} from 'swr'
import {
  withErrorHandling,
  withHelmet,
  withPropsPresent,
  withServiceData,
  withServicesData,
  withMeData
} from '../../hoc'
import {RemovalConfirmationModal} from '../shared'
import {removeService} from '../../backend'

const _RemoveService = (
  {
    service,
    navigate,
    history,
    mutateServices,
    mutateMe,
    removeService,
    basePath = '/c/services'
  }
) => {

  const onRemovalConfirmed = async (service) => {
    await removeService(service.id)
    cache.clear()
    mutateServices()
    mutateMe()
    navigate(basePath)
  }

  const onRemovalCancelled = () => {
    goBack(history, navigate, basePath)
  }

  if (!service) {
    return null
  }

  return (
    <div data-testid='remove-service-modal'>
      <RemovalConfirmationModal
        confirmingRemovalOf='service'
        propName='name'
        expectedPropValue={service.name}
        onRemovalApproved={async () => onRemovalConfirmed(service)}
        onRemovalCancelled={onRemovalCancelled}/>
    </div>
  )
}

let RemoveService = (props) => {
  const {handleError} = props
  const history = window.history
  props = {
    ...props,
    history,
    removeService: handleError(removeService)
  }
  return (<_RemoveService {...props}/>)
}

RemoveService = withPropsPresent(RemoveService, ['service'])
RemoveService = withHelmet(RemoveService, 'Remove Service')
RemoveService = withServiceData(RemoveService, 'Loading service...')
RemoveService = withServicesData(RemoveService, 'Loading services...')
RemoveService = withMeData(RemoveService, 'Loading profile...')
RemoveService = withErrorHandling(RemoveService)
RemoveService = memo(RemoveService)

export {_RemoveService, RemoveService}

export default RemoveService